import { render } from "./AppListViewComponent.vue?vue&type=template&id=63d02441"
import script from "./AppListViewComponent.vue?vue&type=script&lang=js"
export * from "./AppListViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__